import { useEffect, type Dispatch, type SetStateAction } from "react";
import type { ActivityDockAssistLevel } from "@/lib/activityDock/assistLevel";
import { canHandleExplicitDockOpen } from "@/lib/activityDock/assistLevel";
import {
  ACTIVITY_DOCK_OPEN_EVENT,
  type ActivityDockOpenDetail,
} from "./activityDockOpenEvent";

export function useActivityDockExplicitOpen(
  assistLevel: ActivityDockAssistLevel,
  setOpen: Dispatch<SetStateAction<boolean>>,
  onOpened?: (detail: ActivityDockOpenDetail | undefined) => void,
): void {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const handler = (e: Event) => {
      const detail = (e as CustomEvent<ActivityDockOpenDetail>).detail;
      if (!detail?.force && !canHandleExplicitDockOpen(assistLevel)) return;
      if (detail?.toggle) {
        setOpen((current) => !current);
        if (!detail.expandAsk && detail.focusSection == null) return;
      } else {
        setOpen(true);
      }
      onOpened?.(detail);
    };
    window.addEventListener(ACTIVITY_DOCK_OPEN_EVENT, handler);
    return () => window.removeEventListener(ACTIVITY_DOCK_OPEN_EVENT, handler);
  }, [assistLevel, onOpened, setOpen]);
}
